export enum ClientSearchPlaceholder {
    RXWORKS = 'Last name, last name with patient, phone, email or client ID',
    ROBOVET = 'Phone, email or client ID',
    MERLIN = 'Last name, last name with patient, phone, email or client ID',
    TELEOS = 'Last name, last name with patient, phone, email or client ID',
    PROVET = 'Last name, phone, email or client ID'
}
